import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./Spotreba.scss";

// prop types
import odberneMiestaPropTypes from "../../propTypes/odberneMiestaPropTypes";
import spotrebaPropTypes from "../../propTypes/spotrebaPropTypes";

// actions
import * as appHeaderActions from "../../actions/appHeaderActions";

// core web components
import ChartComponent from "../../coraWebComponents/chart/ChartComponent";
import Flags from "../../coraWebComponents/utils/flags";
import LoadingPanel from "../../coraWebComponents/LoadingPanel";

// components
import Detail from "./Detail";
import Grid from "../../zisComponents/grid/Grid";
import ErrorMsg from "../ErrorMsg";

const _valueAxis = [
  {
    title: { text: "kWh" },
    name: "teplo",
  },
  {
    title: { text: "m3" },
    name: "voda",
  },
];

const _categories = [
  "jan",
  "feb",
  "mar",
  "apr",
  "maj",
  "jun",
  "jul",
  "aug",
  "sep",
  "okt",
  "nov",
  "dec",
];

class Spotreba extends React.Component {
  constructor(props) {
    super(props);
    this.Detail = Detail([..._categories]);
  }

  // GRID PROPS
  genGridSchema = () => {
    return [
      { field: "NAZOV", title: "Názov", width: "auto" },
      { field: "POPIS", title: "Popis", width: "auto" },
    ];
  };

  // CHART PROPS
  buildSeriesProps = (data) => {
    return data.map((d, i) => {
      const axis = d.name.includes("Voda") ? "voda" : "teplo";

      return { ...d, axis, gap: 2, spacing: 0.25, key: i, type: "column" };
    });
  };

  // system methods
  componentDidMount = async () => {
    const { showAppHeader, changeHeaderTitle } = this.props;

    showAppHeader(true);
    changeHeaderTitle("Spotreba");
  };

  render() {
    const { isOMPicked, isLoading, gridData, chartData } = this.props;

    return (
      <div className="row m-0 component">
        <div className="col p-0">
          <Grid
            className={isOMPicked ? "" : "hidden"}
            data={gridData}
            detail={this.Detail}
            isLoading={isLoading}
            onChange={() => { }}
            onGet={() => { }}
            onGetList={() => { }}
            primaryField="ID"
            schema={this.genGridSchema()}
            total={gridData.length}
            hidden={Flags.FILTER}
          />
          {isOMPicked && (
            <>
              <ChartComponent
                zoomable={false}
                style={{ minWidth: 500 }}
                titleProps={{ text: "" }}
                legendProps={{ position: "top" }}
                seriesItemProps={this.buildSeriesProps(chartData)}
                valueAxisItemProps={_valueAxis}
                categoryAxisItemProps={{
                  categories: _categories,
                  title: { text: "Obdobie" },
                  axisCrossingValues: [0, 12],
                }}
              />
              <ChartComponent
                className="mobile"
                zoomable={false}
                style={{ minWidth: 500 }}
                titleProps={{ text: "" }}
                legendProps={{ position: "top" }}
                seriesItemProps={this.buildSeriesProps(chartData)}
                valueAxisItemProps={_valueAxis}
                categoryAxisItemProps={{
                  categories: _categories,
                  title: { text: "Obdobie" },
                  axisCrossingValues: [0, 12],
                }}
              />
            </>
          )}
          {!isOMPicked && <ErrorMsg text="Vyberte odberne miesto" />}
          <LoadingPanel isLoading={isLoading} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // spotreba
    gridData: state.spotreba.gridData,
    chartData: state.spotreba.chartData,
    isLoading: state.spotreba.isLoading,

    // OM
    isOMPicked: state.OM.isPicked,
  };
};

const mapDispatchToProps = (dispatch) => ({
  changeHeaderTitle: (title) =>
    dispatch(appHeaderActions.changeHeaderTitle(title)),
  showAppHeader: (show) => dispatch(appHeaderActions.showAppHeader(show)),
});

Spotreba.propTypes = {
  gridData: PropTypes.arrayOf(spotrebaPropTypes.gridData),
  chartData: PropTypes.arrayOf(spotrebaPropTypes.chartData),
  changeHeaderTitle: PropTypes.func,
  isLoading: PropTypes.bool,
  isOMPicked: PropTypes.bool,
  OM: odberneMiestaPropTypes.odberneMiesto,
  showAppHeader: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Spotreba);
